var pathname = window.location.pathname;
var sizeChildrenBody = $('body').children().length -1
var divPather = '<div class="buy-floating-button"></div>';
var divContainer = '<div class="buy-floating-button__contrainer" style="display:none"></div>';
var elementTextFirst = '<div class="buy-floating-button__element-first" ></div>';
var elementTextSecond = '<div class="buy-floating-button__element_second"></div>';
var elementTextFirstChildren ='<p class="buy-floating-button__element-first-text" ></p>';
var elementTextSecondChildren ='<p class="buy-floating-button__element-second-text" ></p>';

function formatReal( int ){
	var tmp = int+'';
	tmp = tmp.replace(/([0-9]{2})$/g, ",$1");

	if( tmp.length > 6 )
			tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
	return tmp;
}


const floatingButton = {
    getProduct:function(){
        var productItem = $.getJSON(window.location.pathname+".js")
        productItem.done(function (product) {            
            textFirst = product.title;
            qtdParcel = 10;
            idProduct = product.variants.map( item =>idProduct = item.id );
            valueParcelsComparePrice = 0;
    
            if( product.compare_at_price !== null){
                valueParcelsComparePrice = product.compare_at_price.toFixed()/qtdParcel;
                valueParcelsComparePrice = formatReal(valueParcelsComparePrice.toFixed());
            }
            
            valueParcelsPrice = product.price/qtdParcel;    
            valueParcelsPrice = formatReal(valueParcelsPrice.toFixed());            
        });
    },
    validatePage:function(){    
        if( pathname.search('collections') === 1 ){
            page = 'collections'
        } else if( pathname.search('products') === 1 ) {
            page = 'products'
        }

        if( page === 'products' || page === 'collections' ){  
            this.renderPage()
        }
    },
    addProductInHTML:function(){

    },
    renderPage: function(){       
        this.getProduct()
        setTimeout(()=>{    
            var lgpdExistis = $('[aria-label="cookieconsent"]').length > 0;            
            $('body').children().eq(sizeChildrenBody).after(divPather);
            $('.buy-floating-button').append(divContainer); 
            $('.buy-floating-button').hide();  
            $('.lh-btn').eq(1).parents('[data-section-id]').addClass('element-moved')
            $('.lh-btn').eq(1).hide()

            $('.buy-floating-button').fadeIn('slow')
            $('.buy-floating-button__contrainer').css('display', 'flex')
    
            $('.buy-floating-button__contrainer').append(`
                <div class="buy-floating-button__button">
                    <a class="buy-floating-button__link" href="/cart/add/${idProduct}" target="_blank" data-ga-action="tracking" data-ga-label="Button" data-lhlink=""> Compre Agora </a>
                </div>
            `);
        
    
            $('.buy-floating-button__contrainer').prepend( elementTextFirst )     
            $('.buy-floating-button__contrainer .buy-floating-button__button').prepend( elementTextSecond )
    
            // $('.buy-floating-button__element-first').append(elementTextFirstChildren);
            // $('.buy-floating-button__element-first-text').text(textFirst)
    
            $('.buy-floating-button__element_second').append( elementTextSecondChildren)

            if( lgpdExistis ){
                let outerHeightLGPD = $('[aria-label="cookieconsent"]').outerHeight() -1;
                $('.buy-floating-button').css('bottom', outerHeightLGPD)
            }


            if( valueParcelsComparePrice !== 0){
                $('.buy-floating-button__element-second-text').html(`
                <span class="price-2">De ${qtdParcel}x de R$${valueParcelsComparePrice}</span>
                <span class="price-1">por ${qtdParcel}x de R$${valueParcelsPrice}</span> 
                `)
            } else {
                $('.buy-floating-button__element-second-text').html(`
                    <span class="price-1">De ${qtdParcel}x de R$${valueParcelsPrice}</span> 
                `)
            }
    
            $('[data-lhi=btn]').parents('[data-section-id]').hide()
            $('.element-moved').hide()
        },500)     
    }
}
/*
window.onload = (()=>{
    countElementOfArray = pathname.split('/')
    if( countElementOfArray.length > 3 ){          
        floatingButton.renderPage()
    } else if ( countElementOfArray.length == 3 ){
        var getProduct = $.getJSON(pathname)
        getProduct.done(function(item){
            if( pathname.search('collections') !== 1 && item.product.product_type !== 'Cartões-presente' ){
                floatingButton.renderPage()
            }
        })
    }

    setTimeout(()=>{        
        $('.cc-btn.cc-dismiss').on('click', function(e){
            e.preventDefault();
            $('.buy-floating-button').removeAttr('style')
        })
    }, 500)  
})
*/